import React from "react";
import { Navigate } from "react-router-dom";
import {
  useAdminDashboardEnabled,
  useInternalAffairsEnabled,
} from "./featureFlag";
import NotFound404 from "@/pages/NotFound";
import StationAdminDashboard from "./StationAdminDashboard";

/**
 * Index of the Station Admin area (`/station-admin`). The Overview dashboard is
 * gated by `admin-dashboard`; when that flag is off but `internal-affairs` is
 * on, land the user on the one tab they do have (IA) instead of showing the
 * dashboard or 404ing. The surrounding RequireStationAdminArea has already
 * ensured at least one of the two flags is on, so the final 404 is defensive.
 */
const StationAdminIndex: React.FC = () => {
  const dashboardEnabled = useAdminDashboardEnabled();
  const iaEnabled = useInternalAffairsEnabled();
  if (dashboardEnabled) return <StationAdminDashboard />;
  if (iaEnabled) return <Navigate to="internal-affairs" replace />;
  return <NotFound404 />;
};

export default StationAdminIndex;
